const REVEAL_SELECTOR = '.reveal, .reveal-left, .reveal-right';
const VISIBLE_CLASS = 'visible';
const THRESHOLD = 0.12;

/**
 * Adds the `visible` class to any element matching REVEAL_SELECTOR
 * once it crosses the threshold in the viewport. One-shot per element.
 */
export function initScrollReveal() {
  const targets = document.querySelectorAll(REVEAL_SELECTOR);
  if (targets.length === 0) return;

  if (!('IntersectionObserver' in window)) {
    targets.forEach((el) => el.classList.add(VISIBLE_CLASS));
    return;
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add(VISIBLE_CLASS);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: THRESHOLD });

  targets.forEach((el) => observer.observe(el));
}
